import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import _ from 'underscore'
const getInstallmentBanks = (data) => {
  return new Promise((resolve, reject) => {

    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    let url = `${CONSTANT.REQUEST_HOST}${query}`

    Api.get(url, {
        headers: {
          'X-Host': 'mall.installment.bank-list',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const getInstallmentPayPeriods = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.installment.pay-periods',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const sendPaySms = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.pay.sms-code',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const commitInstallment = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.installment.commit',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const checkIsBankCardSupport = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.pay.check-card-open-pay',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const openBankCardPayment = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.pay.card-open-pay',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const sendSmsForOpenPay = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.pay.open-pay.sms',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const toOpenPay = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.pay.open-pay',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const checkPayResult = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.sdyxpay.check',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
/*yeoman-template-point-1*/
export default {
  getInstallmentBanks,
  getInstallmentPayPeriods,
  sendPaySms,
  commitInstallment,
  checkIsBankCardSupport,
  openBankCardPayment,
  sendSmsForOpenPay,
  toOpenPay,
  checkPayResult,
/*yeoman-template-point-2*/
}
